var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 75,
    viewBox: "0 0 300 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.7279 0H21.5759L0 37.3705L21.5759 74.7414H64.7279L86.3038 37.3705L64.7279 0Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9977 70.5473H62.306L81.4602 37.3713L62.306 4.19531H23.9977L4.84351 37.3713L23.9977 70.5473Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5352 29.2411C24.5113 29.2411 25.3025 28.4499 25.3025 27.4738C25.3025 26.4978 24.5113 25.7065 23.5352 25.7065C22.5592 25.7065 21.7679 26.4978 21.7679 27.4738C21.7679 28.4499 22.5592 29.2411 23.5352 29.2411Z",
    fill: "#E2E2E2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5352 39.1376C24.5113 39.1376 25.3025 38.3464 25.3025 37.3703C25.3025 36.3943 24.5113 35.603 23.5352 35.603C22.5592 35.603 21.7679 36.3943 21.7679 37.3703C21.7679 38.3464 22.5592 39.1376 23.5352 39.1376Z",
    fill: "#E2E2E2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5352 49.0341C24.5113 49.0341 25.3025 48.2428 25.3025 47.2668C25.3025 46.2908 24.5113 45.4995 23.5352 45.4995C22.5592 45.4995 21.7679 46.2908 21.7679 47.2668C21.7679 48.2428 22.5592 49.0341 23.5352 49.0341Z",
    fill: "#E2E2E2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.536 26.0596H30.9576V28.8872H64.536V26.0596Z",
    fill: "#E2E2E2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.536 35.9561H30.9576V38.7837H64.536V35.9561Z",
    fill: "#E2E2E2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.536 45.854H30.9576V48.6817H64.536V45.854Z",
    fill: "#E2E2E2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M278.424 0H235.272L213.696 37.3705L235.272 74.7414H278.424L300 37.3705L278.424 0Z",
    fill: "#E6E6E6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M237.694 70.5473H276.002L295.156 37.3713L276.002 4.19531H237.694L218.54 37.3713L237.694 70.5473Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M237.231 29.2411C238.207 29.2411 238.998 28.4499 238.998 27.4738C238.998 26.4978 238.207 25.7065 237.231 25.7065C236.255 25.7065 235.464 26.4978 235.464 27.4738C235.464 28.4499 236.255 29.2411 237.231 29.2411Z",
    fill: "#E2E2E2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M237.231 39.1376C238.207 39.1376 238.998 38.3464 238.998 37.3703C238.998 36.3943 238.207 35.603 237.231 35.603C236.255 35.603 235.464 36.3943 235.464 37.3703C235.464 38.3464 236.255 39.1376 237.231 39.1376Z",
    fill: "#E2E2E2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M237.231 49.0341C238.207 49.0341 238.998 48.2428 238.998 47.2668C238.998 46.2907 238.207 45.4995 237.231 45.4995C236.255 45.4995 235.464 46.2907 235.464 47.2668C235.464 48.2428 236.255 49.0341 237.231 49.0341Z",
    fill: "#E2E2E2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M278.232 26.0596H244.654V28.8872H278.232V26.0596Z",
    fill: "#E2E2E2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M278.232 35.9561H244.654V38.7837H278.232V35.9561Z",
    fill: "#E2E2E2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M278.232 45.854H244.654V48.6817H278.232V45.854Z",
    fill: "#E2E2E2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M171.366 0.363281H128.633L107.267 37.3709L128.633 74.3788H171.366L192.733 37.3709L171.366 0.363281Z",
    fill: "#E6E6E6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M131.032 70.2252H168.968L187.936 37.3714L168.968 4.51758H131.032L112.063 37.3714L131.032 70.2252Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M130.574 29.3196C131.54 29.3196 132.324 28.536 132.324 27.5695C132.324 26.6029 131.54 25.8193 130.574 25.8193C129.607 25.8193 128.823 26.6029 128.823 27.5695C128.823 28.536 129.607 29.3196 130.574 29.3196Z",
    fill: "#055D54"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M130.574 39.1208C131.54 39.1208 132.324 38.3373 132.324 37.3707C132.324 36.4042 131.54 35.6206 130.574 35.6206C129.607 35.6206 128.823 36.4042 128.823 37.3707C128.823 38.3373 129.607 39.1208 130.574 39.1208Z",
    fill: "#055D54"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M130.574 48.9206C131.54 48.9206 132.324 48.1371 132.324 47.1705C132.324 46.204 131.54 45.4204 130.574 45.4204C129.607 45.4204 128.823 46.204 128.823 47.1705C128.823 48.1371 129.607 48.9206 130.574 48.9206Z",
    fill: "#055D54"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M171.176 26.1694H137.924V28.9696H171.176V26.1694Z",
    fill: "#055D54"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M171.176 35.9707H137.924V38.7709H171.176V35.9707Z",
    fill: "#055D54"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M171.176 45.7705H137.924V48.5707H171.176V45.7705Z",
    fill: "#055D54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyIcon);
export default __webpack_public_path__ + "static/media/empty-icon.7895899febbb520622e21da47ca296e2.svg";
export { ForwardRef as ReactComponent };